export const appSettings = {
  apiUrl: process.env.REACT_APP_API_URL,
  clientUrl: process.env.REACT_APP_SIMPLICITY_KEYSTONE_URL,
};
